import './assets/style.scss'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'jsvectormap/dist/jsvectormap.css'
import 'flatpickr/dist/flatpickr.css'
import 'simplebar-vue/dist/simplebar.min.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Select from 'primevue/select'
import ToastService from 'primevue/toastservice'

import App from './App.vue'
import router from './router'
import VueApexCharts from 'vue3-apexcharts'

const app = createApp(App)

// Create Pinia instance
const pinia = createPinia()

// Use plugins
app.use(pinia)
app.use(router)
app.use(VueApexCharts)
app.use(ToastService)

// Register PrimeVue components
app.component('DataTable', DataTable)
app.component('ColumnPrime', Column)
app.component('SelectPrime', Select)

app.use(PrimeVue, { theme: 'none' })

// Mount the app
app.mount('#app')

// Initialize auth store after app is mounted
import { nextTick } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { initializeUserType, setUserType } from '@/utils/roleHandler'

nextTick(() => {
  const authStore = useAuthStore()
  authStore.initializeFromStorage()

  // If auth store has user data, sync it with roleHandler
  if (authStore.isAuthenticated && authStore.user?.userType) {
    setUserType(authStore.user.userType)
  } else {
    initializeUserType()
  }

  console.log('🚀 App initialized:', {
    isAuthenticated: authStore.isAuthenticated,
    user: authStore.user,
    userType: authStore.user?.userType,
    storeInitialized: authStore.isInitialized,
    storage: {
      auth: localStorage.getItem('auth') ? 'present' : 'missing',
      user_type: localStorage.getItem('user_type') ? 'present' : 'missing',
      user_data: localStorage.getItem('user_data') ? 'present' : 'missing'
    }
  })
})
